import * as types from './Types.js';

export function findRestosAPagarProcessados(filtro) {
  return ({ fetch }) => ({
    type: types.RESTOSAPAGARPROCESSADOS,
    payload: {
      promise: fetch(`/empenhos/restos-a-pagar?${filtro}`)
    }
  });
}

export function findRestosAPagarNaoProcessados(filtro) {
  return ({ fetch }) => ({
    type: types.RESTOSAPAGARNAOPROCESSADOS,
    payload: {
      promise: fetch(`/empenhos/restos-a-pagar?${filtro}`)
    }
  });
}

export function findOrgao() {
  return ({ fetch }) => ({
    type: types.PROGRAMATICAORGAO,
    payload: {
      promise: fetch('/api/programatica/orgao')
    }
  });
}

export function findUnidade(filtro) {
  return ({ fetch }) => ({
    type: types.PROGRAMATICAUNIDADE,
    payload: fetch(`/api/programatica/unidade?${filtro}`)
  });
}

export function findFuncao(filtro) {
  return ({ fetch }) => ({
    type: types.PROGRAMATICAFUNCAO,
    payload: {
      promise: fetch(`/api/programatica/funcao?${filtro}`)
    }
  });
}

export function findSubFuncao(filtro) {
  return ({ fetch }) => ({
    type: types.PROGRAMATICASUBFUNCAO,
    payload: {
      promise: fetch(`/api/programatica/subFuncao?${filtro}`)
    }
  });
}

export function findPrograma(filtro) {
  return ({ fetch }) => ({
    type: types.PROGRAMATICAPROGRAMA,
    payload: {
      promise: fetch(`/api/programatica/programa?${filtro}`)
    }
  });
}

export function findProjeto(filtro) {
  return ({ fetch }) => ({
    type: types.PROGRAMATICAPROJETO,
    payload: {
      promise: fetch(`/api/programatica/projeto?${filtro}`)
    }
  });
}

export function findElemento(filtro) {
  return ({ fetch }) => ({
    type: types.PROGRAMATICAELEMENTO,
    payload: {
      promise: fetch(`/api/programatica/elemento?${filtro}`)
    }
  });
}

export function findDesdobramento(filtro) {
  return ({ fetch }) => ({
    type: types.PROGRAMATICADESDOBRAMENTO,
    payload: {
      promise: fetch(`/api/programatica/desdobramento?${filtro}`)
    }
  });
}

export function findSubDesdobramento(filtro) {
  return ({ fetch }) => ({
    type: types.PROGRAMATICASUBDESDOBRAMENTO,
    payload: {
      promise: fetch(`/api/programatica/subDesdobramento?${filtro}`)
    }
  });
}

export function findFonteRecurso(filtro) {
  return ({ fetch }) => ({
    type: types.PROGRAMATICAFONTERECURSO,
    payload: {
      promise: fetch(`/api/programatica/fonteRecurso?${filtro}`)
    }
  });
}
